import { apiClient } from './api';
import { ProtokollPage, ProtokollFilter } from '../types/protokoll';

const BASE_URL = '/admin/protokoll';

export const ProtokollService = {
  async getProtokoll(
    filter: ProtokollFilter,
    page: number = 0,
    size: number = 20,
    sortBy: string = 'gesendetAm',
    sortDir: string = 'desc'
  ): Promise<ProtokollPage> {
    const params = new URLSearchParams();
    
    if (filter.von) params.append('von', filter.von);
    if (filter.bis) params.append('bis', filter.bis);
    if (filter.kbaAntragsId) params.append('kbaAntragsId', filter.kbaAntragsId);
    if (filter.fin) params.append('fin', filter.fin);
    if (filter.kennzeichenBezirk) params.append('kennzeichenBezirk', filter.kennzeichenBezirk);
    
    params.append('page', page.toString());
    params.append('size', size.toString());
    params.append('sort', `${sortBy},${sortDir}`);
    
    const response = await apiClient.get<ProtokollPage>(`${BASE_URL}?${params.toString()}`);
    return response.data;
  },

  exportToCsv(data: ProtokollPage['content'], filename: string = 'protokoll.csv'): void {
    const headers = [
      'Antrags-ID',
      'KBA-Antrags-ID',
      'Gesendet am',
      'Benutzername',
      'Vorname',
      'Nachname',
      'Client-IP',
      'FIN',
      'Kennzeichen',
      'Geschäftsvorfalltyp',
      'Status',
      'Request XML',
      'Response XML'
    ];

    const escapeCSV = (value: string | null | undefined): string => {
      if (value === null || value === undefined) return '';
      const str = String(value);
      if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes(';')) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    };

    const formatDateTime = (dateString: string | null): string => {
      if (!dateString) return '';
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
    };

    const rows = data.map(entry => [
      entry.antragId,
      escapeCSV(entry.kbaAntragsId),
      formatDateTime(entry.gesendetAm),
      escapeCSV(entry.username),
      escapeCSV(entry.nutzerVorname),
      escapeCSV(entry.nutzerNachname),
      escapeCSV(entry.clientIp),
      escapeCSV(entry.fin),
      escapeCSV(entry.kennzeichen),
      escapeCSV(entry.geschaeftsvorfallTyp),
      escapeCSV(entry.status),
      escapeCSV(entry.requestXml),
      escapeCSV(entry.responseXml)
    ].join(','));

    const csvContent = [headers.join(','), ...rows].join('\n');
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
    
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
  }
};
